<script lang="ts">
    import type {RelatedRecordsTable} from '../../../record/kp-related-records-table/types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpRelatedRecordsTable from '../../../record/kp-related-records-table/KpRelatedRecordsTable.svelte';
    import type {
        DocumentDetailReactivePageData,
        DocumentDetailStaticPageData
    } from '../../../record/kp-document-detail-page/types';

    export let relatedTables: RelatedRecordsTable[] = [];

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

{#each relatedTables as relatedTable}
    <section>
        <h3>{relatedTable.title}</h3>
        <KpRelatedRecordsTable record={model.record}
                               fondId={relatedTable.fondId}
                               relations={relatedTable.relations}
                               originReferenceFieldTypeId={relatedTable.originReferenceFieldTypeId}
                               referenceFieldTypeId={relatedTable.referenceFieldTypeId}/>
    </section>
{/each}